import './css/index.css';
import './css/3rdpartycss/animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/bootstrap.min.css';
//import './css/fontawesome.css';
import 'react-toastify/dist/ReactToastify.css';
import 'yet-another-react-lightbox/styles.css';
import "yet-another-react-lightbox/plugins/captions.css";
import 'driver.js/dist/driver.css';
import "./css/3rdpartycss/DatePicker.css";
import './css/scheme2021.css';
import './css/scheme.css';
import './css/3rdpartycss/carousel.css';
import './css/3rdpartycss/react-datepicker.css';

import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { loadStripe } from "@stripe/stripe-js";

import React from 'react';
import App, { CollectionReptileViewer, AvailableReptileViewer } from './App';
import { ToastContainer } from 'react-toastify';

const versionNumber = "1.1.393";
//const startUp = {serverLocation: 'http://127.0.0.1:5000/', stripePublicKey: 'pk_test_51QQhl0J70hmZNTZUrLFJyi65ygPFyUNLfwgFKnCoIh8HXOa3NeXVSRkumky6KfzKJoXCMeSy4HDONyP2k3FJeFWl00oilQv8Ic'};
const startUp = {serverLocation: 'https://reptool.app/', stripePublicKey: 'pk_live_51QQhl0J70hmZNTZULGBOxpsIu8z3c7RQpjRgLKXo6P2AEEOamUV6i3bVIkz5T0JxBUVNEb1EcjkDYWemLEfpV7Yw005juMdtma'};

const stripePromise = loadStripe(startUp.stripePublicKey);
window.stripePromise = stripePromise;
window.loggedIn = false;
window.serverLocation = startUp.serverLocation;
window.versionNumber = versionNumber;

const root = createRoot(document.getElementById('app'));
const isLocationCollectionView = window.location.href.includes("collection_reptile");
const isLocationAvailableView = window.location.href.includes("available");
const completedPayment = window.location.href.includes("completed_payment");

  if(completedPayment) {
    window.alert("Payment completed successfully. Thank you for your purchase!");
    // remove the completed_payment from the url
    window.history.pushState({}, document.title, window.location.pathname);
  }

  if (isLocationAvailableView) {
    const splitLocation = window.location.href.split("/");
    const params = {
      userId: splitLocation[splitLocation.length - 2]
    }

    root.render(
      <React.StrictMode>
        <AvailableReptileViewer userId={params.userId} />
        <ToastContainer
          position="top-right"
          autoClose={10000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </React.StrictMode>
    );

  } else if (isLocationCollectionView) {
    const params = {}
    window.location.search.replace("?", "").split("&").forEach(arg => {
      const splitArg = arg.split("=");
      params[splitArg[0]] = splitArg[1];
    })
    root.render(
      <React.StrictMode>
        <CollectionReptileViewer reptileId={params.reptileId} userId={params.userId} />
        <ToastContainer
          position="top-right"
          autoClose={10000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </React.StrictMode>
    );
  } else {
    root.render(
      <React.StrictMode>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={10000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />

      </React.StrictMode>
    );
  }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
